// extracted by mini-css-extract-plugin
export var actionButton = "_rb-0";
export var actionMenuContainer = "_rb-i";
export var bubble = "_rb-2";
export var bubbleActionMenu = "_rb-j";
export var bubbleContext = "_rb-6";
export var bubbleItems = "_rb-7";
export var customer = "_rb-3";
export var divider = "_rb-8";
export var fileList = "_rb-9";
export var hiddenComment = "_rb-o";
export var infoAbove = "_rb-a";
export var internal = "_rb-4";
export var lightActionButton = "_rb-1";
export var link = "_rb-b";
export var merchant = "_rb-5";
export var message = "_rb-c";
export var profilePicture = "_rb-e";
export var quillToolbarContainer = "_rb-f";
export var senderDate = "_rb-g";
export var senderDateCustomer = "_rb-h";
export var senderName = "_rb-d";
export var time = "_rb-k";
export var uploadedImage = "_rb-l";
export var username = "_rb-m";
export var xsmall = "_rb-n";